// extracted by mini-css-extract-plugin
module.exports = {"captcha":"styles-module--captcha--ASAUI","captcha__error":"styles-module--captcha__error--n1Erh"};